import { useEffect, useRef, useState } from "react";

/**
 * Custom cursor — pallino oro/celeste con scale on hover su elementi interattivi.
 * Disattivato su touch / coarse pointer.
 */
export const CustomCursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const [enabled, setEnabled] = useState(true);
  const [active, setActive] = useState(false);
  const [hot, setHot] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const m = window.matchMedia("(pointer: fine)");
    setEnabled(m.matches);
    const onChange = () => setEnabled(m.matches);
    m.addEventListener?.("change", onChange);
    return () => m.removeEventListener?.("change", onChange);
  }, []);

  useEffect(() => {
    if (!enabled) return;
    let rx = 0,
      ry = 0,
      x = 0,
      y = 0;
    let raf = 0;

    const onMove = (e) => {
      x = e.clientX;
      y = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate3d(${x - 4}px, ${y - 4}px, 0)`;
      }
    };
    const animate = () => {
      rx += (x - rx) * 0.18;
      ry += (y - ry) * 0.18;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate3d(${rx - 18}px, ${ry - 18}px, 0)`;
      }
      raf = requestAnimationFrame(animate);
    };
    animate();

    const onDown = () => setActive(true);
    const onUp = () => setActive(false);
    const onOver = (e) => {
      const el = e.target;
      if (!el || !el.closest) return;
      const hover = el.closest(
        "a, button, [role='button'], .card-wow, .gallery-tile, [data-cursor='hot']",
      );
      setHot(!!hover);
    };

    window.addEventListener("mousemove", onMove, { passive: true });
    window.addEventListener("mouseover", onOver, { passive: true });
    window.addEventListener("mousedown", onDown);
    window.addEventListener("mouseup", onUp);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      window.removeEventListener("mousedown", onDown);
      window.removeEventListener("mouseup", onUp);
    };
  }, [enabled]);

  if (!enabled) return null;
  return (
    <>
      <div
        ref={ringRef}
        aria-hidden="true"
        className="pointer-events-none fixed top-0 left-0 z-[9999] transition-[width,height,border-color,background-color] duration-300 ease-out"
        style={{
          width: hot ? 56 : 36,
          height: hot ? 56 : 36,
          border: `1.5px solid ${hot ? "rgba(212,175,55,0.85)" : "rgba(0,212,255,0.55)"}`,
          borderRadius: 9999,
          mixBlendMode: "screen",
          boxShadow: hot
            ? "0 0 32px rgba(212,175,55,0.55), 0 0 90px rgba(212,175,55,0.25)"
            : "0 0 20px rgba(0,212,255,0.4)",
          opacity: active ? 0.6 : 1,
        }}
      />
      <div
        ref={dotRef}
        aria-hidden="true"
        className="pointer-events-none fixed top-0 left-0 z-[10000] transition-[width,height,background-color] duration-200"
        style={{
          width: 8,
          height: 8,
          background: hot ? "#D4AF37" : "#00D4FF",
          borderRadius: 9999,
          boxShadow: hot
            ? "0 0 18px rgba(212,175,55,0.95)"
            : "0 0 14px rgba(0,212,255,0.9)",
        }}
      />
    </>
  );
};

export default CustomCursor;
